import React, { useContext, useEffect } from "react";
import { SidebarContext } from "context/SidebarContext";

const ActiveButton = ({ tabValue, step, labelName, goToStep }) => {
  const { setTabIndex } = useContext(SidebarContext);

  useEffect(() => {
    // This will be called after the component has mounted
    setTabIndex(tabValue);
  }, [setTabIndex, tabValue]);

  return (
    <button
      className={`inline-block px-3 py-2  text-sm ${
        tabValue === step
          ? "text-green-600 border-green-600 dark:text-green-500 dark:border-green-500 rounded-t-lg border-b-2"
          : "text-gray-500 opacity-50"
      } focus:outline-none`}
      aria-current="page"
      onClick={() => goToStep(tabValue)}
    >
      {labelName}
    </button>
  );
};

export default ActiveButton;
